<template>
  <div class="modal">
    <div class="withdrawlv2-modal">
      <!-- withdrawlv2 header -->
      <div class="withdrawlv2-header">
        <h1 class="withdrawlv2-header-title">신고하기</h1>
        <a class="common-close-iconwrap cursor" tabindex="0" @click="closeWithdrawl">
          <img class="common-close-iconwrap" src="/media/images/icon/close-black-icon.png" alt="close-black-icon.png" />
        </a>
      </div>

      <!-- withdrawlv2 contents -->
      <div class="withdrawlv2-contents">
        <!-- withdrawl-list -->
        <ul class="withdrawl-list nodesc">
          <li
            class="withdrawl-item cursor"
            v-for="(item, index) in itemList"
            :key="'report' + index"
            :id="index"
            @click="selectItem(item, index)"
          >
            <RadioBox :value="item.isCheck" />
            <span class="withdrawl-item-text">{{ item.text }}</span>
          </li>
          <li class="withdrawl-item other">
            <textarea
              :disabled="!itemList[4].isCheck"
              class="withdrawl-textarea"
              :placeholder="'오류 내용을 입력해주세요. (최대 50자)'"
              v-model="message"
            ></textarea>
          </li>
        </ul>
      </div>

      <!-- withdrawlv2 footer -->
      <div class="withdrawlv2-footer">
        <div class="withdrawl-cancelbtn">
          <BasicButton :bgcolor="'bg-black200'" :fontcolor="'ft-black'" :boxsize="'sm'" @click-btn="closeWithdrawl">
            <template #btnname>취소</template>
          </BasicButton>
        </div>
        <div class="withdrawl-confirmlbtn">
          <BasicButton :boxsize="'sm'" @click-btn="insertMusicReport" :disabled="btnDisabled">
            <template #btnname>확인</template>
          </BasicButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RadioBox from '../../RadioBox/RadioBox.vue';
import BasicButton from '../../BasicButton/BasicButton.vue';
import AlertModalV2 from '../AlertModalV2.vue';
import { insertMusicReportApi } from '@/service/api/playerApi';
export default {
  components: {
    RadioBox,
    BasicButton,
    AlertModalV2
  },
  props: {
    musicid: {
      type: String,
      default: null,
      required: false
    }
  },
  emits: ['close-modal', 'complete-save'],
  data() {
    return {
      message: null,
      userId: this.$cookies.get('userId'),
      itemList: [
        { isCheck: false, text: '노래 끊김' },
        { isCheck: false, text: '곡명/가수명 오류' },
        { isCheck: false, text: '장르 오류' },
        { isCheck: false, text: '앨범 이미지 오류' },
        { isCheck: false, text: '기타' }
      ]
    };
  },
  methods: {
    closeWithdrawl() {
      this.$gatag.event('web_music_report_back_button'); // 음악 신고 페이지 뒤로가기
      this.$emit('close-modal');
    },
    selectItem(item, index) {
      item.isCheck = !item.isCheck;
      if (index === 4 && !item.isCheck) {
        this.message = '';
      }
    },
    async insertMusicReport() {
      const content = this.itemList
        .filter(item => item.isCheck)
        .map(item => {
          if (item.text === '기타') {
            return this.message;
          } else {
            return item.text;
          }
        })
        .join(' , ');

      try {
        const { data } = await insertMusicReportApi(this.musicid, this.userId, content);
        const { resultCd } = data;
        if (resultCd === '0000') {
          this.$emit('complete-save');
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log(error);
      }
    },
    confirm() {}
  },
  computed: {
    btnDisabled() {
      const filterList = this.itemList.filter(item => item.isCheck);
      if (filterList.length > 0) {
        const hasOther = filterList.some(item => item.text === '기타');
        if (hasOther) {
          if (!this.message) {
            return true;
          }
        }
        return false;
      }
      return true;
    }
  }
};
</script>
<style scoped src="@/assets/css/withdrawlv2/withdrawlv2.css"></style>
